// Count from tomorrow in Denmark, independently of the shopper's time zone.
  // UTC calendar arithmetic avoids skipped/repeated hours during DST changes.
  const bmpDeliveryClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function bmpDeliveryParts(date) {
    return Object.fromEntries(bmpDeliveryClock.formatToParts(date)
      .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }
  function bmpDeliveryRange(now, locale) {
    const today = bmpDeliveryParts(now);
    const date = new Date(Date.UTC(today.year, today.month - 1, today.day));
    let start;
    for (let days = 0; days < 7;) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() === 0 || date.getUTCDay() === 6) continue;
      days++;
      if (days === 5) start = new Date(date);
    }
    const options = { day: 'numeric', month: 'long', timeZone: 'UTC' };
    if (date.getUTCFullYear() !== today.year) options.year = 'numeric';
    const formatter = new Intl.DateTimeFormat(locale || 'da', options);
    return formatter.formatRange ? formatter.formatRange(start, date)
      : `${formatter.format(start)} – ${formatter.format(date)}`;
  }
  function bmpDeliveryMidnightDelay(now) {
    const today = bmpDeliveryParts(now);
    const midnight = Date.UTC(today.year, today.month - 1, today.day + 1);
    let instant = midnight;
    // Resolve Denmark's next midnight, including a change of UTC offset.
    for (let pass = 0; pass < 3; pass++) {
      const parts = bmpDeliveryParts(new Date(instant));
      const wallTime = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      instant += midnight - wallTime;
    }
    return Math.max(1000, instant - now.getTime() + 100);
  }
  if (!customElements.get('bmp-delivery-price')) {
    customElements.define('bmp-delivery-price', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section, dialog');
        this.onUpdate = () => this.update();
        ['change', 'input', 'quantity-selector:update'].forEach(type => this.scope?.addEventListener(type, this.onUpdate));
        this.onVisibility = () => { if (!document.hidden) this.update(); };
        if (this.querySelector('[data-delivery-estimate]')) document.addEventListener('visibilitychange', this.onVisibility);
        this.contentObserver = new MutationObserver(() => this.update());
        this.contentObserver.observe(this, { childList: true, subtree: true });
        this.update();
      }
      disconnectedCallback() {
        ['change', 'input', 'quantity-selector:update'].forEach(type => this.scope?.removeEventListener(type, this.onUpdate));
        document.removeEventListener('visibilitychange', this.onVisibility);
        clearTimeout(this.midnightTimer);
        this.contentObserver?.disconnect();
        this.scope = null;
      }
      update() {
        const form = this.hasAttribute('data-cart-delivery') ? null :
          this.closest('product-form-component') || this.scope?.querySelector('product-form-component');
        const input = form?.querySelector('input[name="quantity"]') || this.scope?.querySelector('quantity-selector input[name="quantity"]');
        const quantity = Math.max(1, Number(input?.value) || Number(this.dataset.min) || 1);
        const shipping = quantity >= 3 || this.dataset.shipping === 'false' ? 0 : 4800;
        const money = cents => new Intl.NumberFormat(this.dataset.locale || 'da', { style: 'currency', currency: 'DKK' }).format(cents / 100);
        const cost = this.querySelector('[data-delivery-cost]');
        const total = this.querySelector('[data-delivery-total]');
        if (cost) cost.textContent = shipping === 0 ? this.querySelector('[data-delivery-free]').textContent : money(shipping);
        if (total) total.textContent = money(Number(this.dataset.price) * quantity + shipping);
        const options = form?.querySelectorAll('[name="properties[Personalisering]"]') || [];
        const chosen = [...options].some(option =>
          !option.matches(':disabled') && option.value === 'JA' &&
          (!['checkbox', 'radio'].includes(option.type) || option.checked)
        );
        const personal = this.dataset.personal === 'true' || chosen;
        const standardText = this.querySelector('[data-delivery-standard]');
        const personalText = this.querySelector('[data-delivery-personal]');
        if (standardText) standardText.hidden = personal;
        if (personalText) personalText.hidden = !personal;
        const estimate = this.querySelector('[data-delivery-estimate]');
        clearTimeout(this.midnightTimer);
        if (estimate) {
          estimate.hidden = false;
          const approval = estimate.querySelector('[data-delivery-approval]');
          if (approval) approval.hidden = !personal;
          {
            const now = new Date();
            const dates = estimate.querySelector('[data-delivery-dates]');
            if (!dates) return;
            const range = bmpDeliveryRange(now, this.dataset.locale);
            if (dates.textContent !== range) dates.textContent = range;
            // One scheduled refresh at midnight; no continuous polling.
            this.midnightTimer = setTimeout(() => this.update(), bmpDeliveryMidnightDelay(now));
          }
        }
      }
    });
  }
